class SpaceFloorElements {
  store;
  feId;
  startPoint;


  constructor(store, spaceId, floorelementId) {
    this.store = store;
    this.spaceId = spaceId;
    this.floorelementId = floorelementId;
  }

  static fromJSON(store, json) {
    let { spaceId, floorelementId} = json;
    return new SpaceFloorElements(store, spaceId, floorelementId);
  }
}

export default SpaceFloorElements;
